export const data = {
  categories: [
    {
      id: "Softech-18x",
      name: "SOFTECH",
      cover: require("../assets/images/Softech-min.webp"),
      products: [
        {
          prodName: "MYSTERY BOX",
          price: "310,00 €",
          refrence: "softech_myst_5.2",
          image: require("../assets/Softech/ST3.jpg"),
          album: [
            require("../assets/Softech/ST3.jpg"),
            require("../assets/Softech/ST3-BG1.jpg"),
            require("../assets/Softech/ST3-BG2.jpg")
          ],
          video: ""
        },
        {
          prodName: "TC SIGNATURE MODEL",
          price: "349,00 €",
          refrence: "softech_tc",
          image: require("../assets/Softech/ST4.jpg"),
          album: [
            require("../assets/Softech/ST4.jpg"),
            require("../assets/Softech/ST4-BG1.jpg"),
            require("../assets/Softech/ST4-BG2.jpg")
          ],
          video: ""
        },
        {
          prodName: "MASON TWIN NEO LIME/YELLOW",
          price: "295,00 €",
          refrence: "softech_mhtii_lme/ylw",
          image: require("../assets/Softech/ST5.jpg"),
          album: [
            require("../assets/Softech/ST5.jpg"),
            require("../assets/Softech/ST5-BG1.jpg"),
            require("../assets/Softech/ST5-BG2.jpg")
          ],
          video: "https://www.youtube.com/embed/rfWdnsIsLX8"
        },
        {
          prodName: "ROCKET FISH",
          price: "219,00 €",
          refrence: "softech_rockfish_",
          image: require("../assets/Softech/ST6.jpg"),
          album: [
            require("../assets/Softech/ST6.jpg"),
            require("../assets/Softech/ST6-BG1.jpg"),
            require("../assets/Softech/ST6-BG2.jpg"),
            require("../assets/Softech/ST6-BG3.jpg")
          ],
          video: "https://www.youtube.com/embed/ZpDRe8BDnZA"
        }
      ]
    },
    {
      id: "RRD-90x",
      name: "RRD",
      cover: require("../assets/images/RRD-min.webp"),
      products: [
        {
          prodName: "IAN ARMSTRONG LUCKY FISH V2",
          price: "729,00 €",
          refrence: "24LKFA56",
          image: require("../assets/RRD/RRD1.jpg"),
          album: [require("../assets/RRD/RRD1.jpg")],
          video: "https://player.vimeo.com/video/287464648"
        },
        {
          prodName: "IAN ARMSTRONG HUNGRY HYENA",
          price: "679,00 €",
          refrence: "24HHA57",
          image: require("../assets/RRD/RRD2.jpg"),
          album: [
            require("../assets/RRD/RRD2.jpg"),
            require("../assets/RRD/RRD2-BG1.jpg"),
            require("../assets/RRD/RRD2-BG2.jpg")
          ],
          video: "https://player.vimeo.com/video/287464628"
        },
        {
          prodName: "KIATTA V3",
          price: "443,25 €",
          refrence: "21KI56",
          image: require("../assets/RRD/RRD3.jpg"),
          album: [
            require("../assets/RRD/RRD3.jpg"),
            require("../assets/RRD/RRD3-BG1.jpg"),
            require("../assets/RRD/RRD3-BG2.jpg"),
            require("../assets/RRD/RRD3-BG3.jpg"),
            require("../assets/RRD/RRD3-BG4.jpg")
          ],
          video: ""
        },
        {
          prodName: "STRANA FRIENDLY RIPPER",
          price: "372,60 €",
          refrence: "14STR58",
          image: require("../assets/RRD/RRD4.jpg"),
          album: [
            require("../assets/RRD/RRD4.jpg"),
            require("../assets/RRD/RRD4-BG1.jpg"),
            require("../assets/RRD/RRD4-BG2.jpg"),
            require("../assets/RRD/RRD4-BG3.jpg")
          ],
          video: ""
        },
        {
          prodName: "IAN ARMSTRONG YELLOW TAIL",
          price: "729,00 €",
          refrence: "24YTA60",
          image: require("../assets/RRD/RRD5.jpg"),
          album: [require("../assets/RRD/RRD5.jpg")],
          video: "https://player.vimeo.com/video/287464727"
        },
        {
          prodName: "IAN ARMSTRONG MAMBA",
          price: "1 139,00 €",
          refrence: "24MAA90",
          image: require("../assets/RRD/RRD6.jpg"),
          album: [require("../assets/RRD/RRD6.jpg")],
          video: "https://player.vimeo.com/video/287464673"
        }
      ]
    },
    {
      id: "LIB-TECH-05x",
      name: "LIB TECH",
      cover: require("../assets/images/LibTech-min.webp"),
      products: [
        {
          prodName: "LOST KA SWORDFISH",
          price: "759,99 €",
          refrence: "20SU002",
          image: require("../assets/Libtech/LT1.jpg"),
          album: [
            require("../assets/Libtech/LT1.jpg"),
            require("../assets/Libtech/LT1-BG1.jpg"),
            require("../assets/Libtech/LT1-BG2.jpg")
          ],
          video: ""
        },
        {
          prodName: "LOST QUIVER KILLER",
          price: "759,99 €",
          refrence: "19SU015",
          image: require("../assets/Libtech/LT2.jpg"),
          album: [
            require("../assets/Libtech/LT2.jpg"),
            require("../assets/Libtech/LT2-BG1.jpg")
          ],
          video: "https://player.vimeo.com/video/277560970"
        },
        {
          prodName: "LOST PUDDLE JUMPER HP",
          price: "759,99 €",
          refrence: "19SU001",
          image: require("../assets/Libtech/LT3.jpg"),
          album: [
            require("../assets/Libtech/LT3.jpg"),
            require("../assets/Libtech/LT3-BG1.jpg"),
            require("../assets/Libtech/LT3-BG2.jpg"),
            require("../assets/Libtech/LT3-BG3.jpg"),
            require("../assets/Libtech/LT3-BG4.jpg")
          ],
          video: "https://player.vimeo.com/video/332463815"
        }
      ]
    }
  ]
};
